import { render, staticRenderFns } from "./together-act.vue?vue&type=template&id=57d9c39c&scoped=true&"
import script from "./together-act.vue?vue&type=script&lang=js&"
export * from "./together-act.vue?vue&type=script&lang=js&"
import style0 from "./together-act.vue?vue&type=style&index=0&id=57d9c39c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d9c39c",
  null
  
)

export default component.exports